import React from "react";
import { Settings } from "lucide-react";
import { cn } from "../../lib/cn";

/**
 * EmptyState - centered icon, title, description, optional action.
 * @param {React.ElementType|React.ReactNode} [icon=Settings] - a lucide icon component OR a pre-rendered JSX element
 * @param {string} title
 * @param {string} [description]
 * @param {React.ReactNode} [action]
 * @param {string} [className]
 */
export function EmptyState({
  icon: Icon = Settings,
  title,
  description,
  action,
  className,
  ...props
}) {
  return (
    <div
      className={cn("flex flex-col items-center justify-center px-6 py-12 text-center", className)}
      {...props}
    >
      {/* Safely handle both pre-rendered JSX elements (<Settings />) and component functions (Settings) */}
      {React.isValidElement(Icon) ? (
        Icon
      ) : Icon ? (
        <Icon className="mb-4 h-10 w-10 text-neutral-300 dark:text-neutral-600" aria-hidden="true" />
      ) : null}

      {title && <p className="text-sm font-medium text-neutral-900 dark:text-neutral-100">{title}</p>}
      {description && <p className="mt-1 max-w-sm text-sm text-neutral-500 dark:text-neutral-400">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}